module.exports = __webpack_public_path__ + "img/fan1.png";